import type { printOnDemand, ID } from "common/utils/models";
import { XCircle } from "lucide-react";
import { Button } from "@design-lab/shared/ui";
import { cn } from "tailwind-variants";

type CanvasProductCompositionsProps = {
  composition: printOnDemand.getProduct.Composition;
  isSelected: boolean;
  onSelect: (id: ID) => void;
  onRemove?: ((id: ID) => void) | undefined;
};

export function CanvasProductCompositions(props: CanvasProductCompositionsProps) {
  const { composition, isSelected, onSelect, onRemove } = props;

  const shirtImage =
    composition.surfaces?.front?.picture || composition.surfaces?.frontLeftChest?.picture;

  const handleRemove = () => {
    if (onRemove) {
      onRemove(composition.id);
    }
  };

  return (
    <div className="relative" onClick={() => onSelect(composition.id)}>
      {shirtImage && (
        <>
          <img
            src={shirtImage}
            alt={composition.colorName}
            className={cn(
              "size-10 rounded-lg border-2 border-gray-300 object-contain",
              isSelected && "border-black shadow-md"
            )}
          />
          {onRemove && (
            <div onClick={e => e.stopPropagation()} className="absolute -right-1.5 -top-1.5">
              <Button
                variant="icon"
                className="bg-background size-4 rounded-full p-0.5 shadow-md"
                aria-label="Remove product"
                onPress={handleRemove}
                data-testid="canvas-remove-product-button"
              >
                <XCircle className="size-4 text-red-600" />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
